import { faBullhorn, faEdit, faFileExport, faFloppyDiskPen, faPrint } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { Toast } from '@ygtechnologies/bygr-frontend-component-library';
import { Badge, Button, ConfirmButton, PopupBar } from '@ygtechnologies/rubus-ui';
import React, { useState } from 'react';
import theme from './MeetingApartments.module.scss';

import { printLetters } from '@/services/booking';
import { ResidentialUnitMeetingData } from './MeetingApartments';

export interface MeetingBottomBarProps {
    listWExtra?: ResidentialUnitMeetingData[];
    activeMeetingTypeId?: number;
    onClose(): void;
    showReminderModal(): void;
    showChangeModal(): void;
    adminAccept(): void;
    exportMeetings(): void;
}

export const MeetingBottomBar: React.FC<MeetingBottomBarProps> = ({
    listWExtra,
    activeMeetingTypeId,
    onClose,
    showReminderModal,
    showChangeModal,
    adminAccept,
    exportMeetings,
}) => {
    const [isPrinting, setIsPrinting] = useState<boolean>(false);

    const checkedCount = listWExtra?.filter((x) => x.isChecked).length ?? 0;
    const isOpen = checkedCount > 0;

    return (
        <PopupBar open={isOpen} onCloseClick={onClose} position="bottom">
            <div className={theme.bottomBarContent}>
                <div className={theme.bottomBarLeft}>
                    <Badge appearance="solid" variant="neutral" max={99}>
                        {checkedCount}
                    </Badge>
                    {checkedCount > 1 ? (
                        <Trans>Meetings selected</Trans>
                    ) : (
                        <Trans>Meeting selected</Trans>
                    )}
                </div>
                <div className={theme.bottomBarRight}>
                    <Button variant="tertiary" icon={faBullhorn} onClick={showReminderModal}>
                        <Trans>Send reminder</Trans>
                    </Button>
                    <Button variant="tertiary" icon={faEdit} onClick={showChangeModal}>
                        <Trans>Edit</Trans>
                    </Button>
                    <ConfirmButton
                        variant="tertiary"
                        icon={faFloppyDiskPen}
                        onConfirm={adminAccept}
                        dialogTitle={<Trans>Confirm meetings</Trans>}
                        dialogBody={
                            <>
                                <Trans>This will register in system as admin confirmed the following units:</Trans>
                                <br />
                                {listWExtra!
                                    .filter((x) => x.isChecked)
                                    .map((x, index) => (
                                        <div key={index}>
                                            - {x.name} - {x.residentialUnitGroupName}
                                        </div>
                                    ))}
                            </>
                        }>
                        <Trans>Admin accept</Trans>
                    </ConfirmButton>
                    <Button variant="tertiary" icon={faFileExport} onClick={exportMeetings}>
                        <Trans>Export</Trans>
                    </Button>
                    <Button
                        variant="tertiary"
                        icon={faPrint}
                        loading={isPrinting}
                        onClick={async () => {
                            const checkedUnits = listWExtra?.filter((x) => x.isChecked);
                            if (activeMeetingTypeId && checkedUnits && checkedUnits.length > 0) {
                                setIsPrinting(true);
                                await printLetters(
                                    activeMeetingTypeId,
                                    checkedUnits.map((x) => x.id)
                                )
                                    .catch(() => Toast.error(<Trans>Something went wrong</Trans>))
                                    .finally(() => setIsPrinting(false));
                            }
                        }}>
                        <Trans>Generate PDF</Trans>
                    </Button>
                </div>
            </div>
        </PopupBar>
    );
};
